<template>
	<div>
		<div class="center center-padding">
			<div style="background:var(--grey-3);text-align:center;padding-top:10px;padding-bottom:10px;margin-top:10px;border-radius: 10px;">
				Du måste logga in 
				<Button label="ÅF-Login" @click="this.$emit('showSubMenuLogin')" style="margin-left:10px;" />
			</div>

		</div>
	</div>
</template>
<script>

// <LoginRequired v-if="!this.isLoggedIn" @showSubMenuLogin="(() => { this.$emit('showSubMenuLogin') })" />

export default {
	name: "LoginRequired",

};
</script>

<style scoped></style>